import React, { useCallback, useEffect, useRef } from 'react';
import { ChatType } from '../../types/chat.types';
import ProgressContainer from '../common/ProgressContainer';
import useProgress from '../../hooks/useProgress';

type ChatProps = {
  chat: ChatType;
  sendFile: (fileName: string, fileType: string, divId: string) => void;
};

function Chat(props: ChatProps) {
  const fileUploadStartedRef = useRef(false);
  const { progressRef } = useProgress();
  const { chat, sendFile } = props;
  const isChatBot = chat.senderType !== 'USER';

  function openLinkInNewWindow(url: string) {
    const width = 1200;
    const height = 900;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;

    // Specify the width, height, and position of the new window
    const windowFeatures = `width=${width},height=${height},left=${left},top=${top}`;
    // Open the link in a new window
    window.open(url, '_blank', windowFeatures);
  }

  const renderChatMsg = () => {
    if (chat.type === 'chat') {
      return (
        <div className="p-3">
          <p id={chat?.divId} className="text-sm whitespace-pre-line">
            {typeof chat?.msg === 'string' ? chat.msg.trim() : ''}
            {chat?.url && (
              <span>
                <button
                  className="text-blue-500 underline text-left"
                  onClick={() => openLinkInNewWindow(chat.url as string)}
                >
                  {chat?.url}
                </button>
              </span>
            )}
          </p>
        </div>
      );
    }
    if (chat.loading) {
      return (
        <div className="relative w-full min-w-[200px] h-[200px] bg-white flex justify-center items-center">
          <ProgressContainer ref={progressRef} />
        </div>
      );
    }
    if (chat.fileType && chat.fileType.startsWith('image/')) {
      return (
        <div className="pb-3">
          <img
            src={chat.msg}
            alt={chat.fileName}
            className="rounded-t-md"
            style={{ maxWidth: '100%', maxHeight: '300px' }}
          />
          <p className="pt-1 px-1">{chat.fileName || chat.msg}</p>
        </div>
      );
    }
    if (chat.fileType && chat.fileType.startsWith('application/pdf')) {
      return (
        <div className="pb-3">
          <embed src={chat.msg} type="application/pdf" width="100%" />
          <p className="pt-1 px-1">{chat.fileName || chat.msg}</p>
        </div>
      );
    }
    return (
      <div className="pb-3">
        <button
          className="rounded-lg flex items-center mb-[-.7rem] p-2"
          type="button"
        >
          {chat.fileName}
          <a href={chat.msg} download={chat.fileName} className="px-2">
            <IconDownloadCircle width={25} height={25} />
          </a>
        </button>
      </div>
    );
  };

  const uploadFile = useCallback(
    async (file: any, divId: string) => {
      try {


        let fileType;
        if (file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
          fileType = 'application/xlsx'
          sendFile(file.msg, fileType, divId);
        }
        else {
          sendFile(file.msg, file.type, divId);
        }
        // await uploadFileToS3(file, updateProgressCircle);
        // console.log("file type---------------------", fileType)
        // sendFile(file.name, file.type, divId);
        // dispatch({
        //   type: FILE_UPLOADED_EVENT,
        //   payload: {
        //     divId: divId,
        //   },
        // });
      } catch (err) {
        console.error({ err });
      }
    },
    [sendFile],
  );

  useEffect(() => {
    if (
      !chat.loading ||
      !chat.file ||
      !chat.divId ||
      chat.uploaded ||
      fileUploadStartedRef.current
    ) {
      return;
    }
    fileUploadStartedRef.current = true;
    uploadFile(chat, chat.id);
  }, [
    chat,
    chat.divId,
    chat.file,
    chat.id,
    chat.loading,
    chat.uploaded,
  ]);
  const clientType = process.env.REACT_APP_CLIENT;

  return (
    <div className="flex flex-col flex-grow">
      <div
        className={`flex w-full mt-2 space-x-3 max-w-5xl ${isChatBot ? '' : 'ml-auto justify-end'
          }`}
      >
        {isChatBot ? (
          clientType === "salesbot2290ai" ? (
          <div className="ai2290-brand-bg">
            <div className="ai2290-brand-icon"></div>
          </div>
          ):(
            <div className="aitax1099-brand-bg">
            <div className="aitax1099-brand-icon"></div>
          </div>
          )
        ) : (
          // <div className=""></div>
          // <div className="w-10 h-10 min-w-10 bg-primary text-white ml-2 flex items-center justify-center rounded-full text-xl font-semibold order-last">
          //   U
          // </div>
          ""
        )}
        <div className={`${isChatBot ? 'text-start' : 'text-end'} `}>
          <div
            className={
              isChatBot || chat.fileType
                ? 'bg-white rounded-r-lg rounded-bl-lg'
                : 'bg-[#F0F1F3] text-black rounded-l-lg rounded-br-lg'
            }
          >
            {renderChatMsg()}
            <div id={`${chat.divId}-clarify-list`}></div>
            <div id={`${chat.divId}-source-list`}></div>
          </div>
          <span className=" text-gray-500 leading-none text-start text-[12px]">
            {chat.time}
          </span>
        </div>
      </div>
    </div>
  );
}

export default React.memo(Chat);

function IconDownloadCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      // height="1em"
      // width="1em"
      {...props}
    >
      <path d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2M8 17h8v-2H8v2m8-7h-2.5V6h-3v4H8l4 4 4-4z" />
    </svg>
  );
}
